import useProfile from "api/UserResource/useProfile";
import ChangePassword from "./ChangePassword";
import AccountPage from "../AccountPage";
import AccountLayout from "../AccountLayout";

const Passwords = () => {
	const { data: profile, isLoading } = useProfile();
	return (
		<AccountPage>
			<AccountLayout isLoading={isLoading} profile={profile?.data}>
				<ChangePassword />
			</AccountLayout>
		</AccountPage>
	);
};
export default Passwords;
